import { useState, useEffect } from "react";
import { getPendingEnvironmentSwitch, setPendingEnvironmentSwitch, switchEnvironment } from "./environment-store";

/**
 * When the env screen navigates to login after user confirms a switch, the pending
 * switch is consumed here to avoid running clearAuth/setEnvironment while the
 * env screen is still mounted (which can cause an RN/Hermes crash).
 * Use on the login screen (or any single consumer after navigation).
 */
export function usePendingEnvironmentSwitch(): { isSwitching: boolean } {
  const [isSwitching, setIsSwitching] = useState(false);

  useEffect(() => {
    const pending = getPendingEnvironmentSwitch();
    if (!pending) return;
    setIsSwitching(true);
    switchEnvironment(pending)
      .finally(() => {
        setPendingEnvironmentSwitch(null);
        setIsSwitching(false);
      })
      .catch((err) => {
        console.error("[usePendingEnvironmentSwitch] Switch failed:", err);
      });
  }, []);

  return { isSwitching };
}
